import { useIntl } from 'react-intl';
import sanitizeHtml from '@alltrails/core/utils/sanitizeHtml';
import Profile from '@alltrails/denali/icons/Profile';
import type { PageUIReviewHighlight } from '../../../utils/PageUI/pageUI';
import styles from './PageUIReviewQuote.module.scss';

const sanitizeConfig = { ALLOWED_TAGS: ['em'] };

type Props = {
  reviewHighlight: PageUIReviewHighlight;
};

/**
 * A compact quote from a member's review, laid out similar to a trail review.
 */
export default function PageUIReviewQuote({ reviewHighlight }: Props) {
  const intl = useIntl();
  const __html = sanitizeHtml(reviewHighlight.textWithHighlighting, sanitizeConfig);
  const reviewDate = reviewHighlight.createdAt ? new Date(reviewHighlight.createdAt) : undefined;
  const hasDate = reviewDate && !Number.isNaN(reviewDate.getTime());

  const avatarLabel = 'Community insight'; // hwandrew TODO: XPLR-204 translations

  return (
    <figure className={styles.reviewQuote}>
      <figcaption className={styles.reviewer}>
        {/* The server doesn't send the reviewer, so this is a generic avatar */}
        <span aria-label={avatarLabel} className={styles.avatar} role="img">
          <Profile size="xs" />
        </span>
        {hasDate && (
          <time dateTime={reviewHighlight.createdAt}>{intl.formatDate(reviewDate, { month: 'short', day: 'numeric', year: 'numeric' })}</time>
        )}
      </figcaption>
      <blockquote className={styles.quote} dangerouslySetInnerHTML={{ __html }} />
    </figure>
  );
}
